module.exports = __webpack_public_path__ + "static/media/Vectoroff.31c6bfbf.svg";